import * as React from "react";
import { useId } from "react-id-generator";
import {
  ProcedureDetailType,
  ProcedureEntity,
} from "../../../../application/domain/procedures/procedure-entity";
import { UpdateButton } from "./update-button";
import { useState } from "react";
import { ProcedureDetail } from "@graffer-inc/cloud-gov-core";
import { fetchProcedureQuota } from "../../../../application/service/smart-apply/procedure-detail/procedure-quota-service";
import { Toggle } from "@graffer-inc/console-design-kit";

interface DetailEditProps {
  procedure: ProcedureEntity;
  onDraftUpdate: (draft: ProcedureDetailType) => void;
}

export const AuthLevel: React.FC<DetailEditProps> = ({
  procedure,
  onDraftUpdate,
}) => {
  const [detail, setDetail] = useState(
    new ProcedureDetail(JSON.parse(JSON.stringify(procedure.getLiveDetail()))),
  );

  const [jpkiToggleId] = useId();
  const [mojToggleId] = useId();

  // 申請数上限設定時は無効
  const [exists, setExists] = useState<boolean>(false);
  React.useEffect(() => {
    const fetchExists = async () => {
      const quota = await fetchProcedureQuota(procedure.id);
      setExists(!!quota);
    };
    fetchExists();
  }, [procedure.id, setExists]);
  if (exists) {
    return <QuotaSettingConflictMessage />;
  }

  return (
    <>
      <div className="columns">
        <div className="column">
          <div className="field">
            <Toggle
              id={jpkiToggleId}
              disabled={!detail.isIndividualOnly() || procedure.isArchived()}
              label={"公的個人認証による電子署名"}
              description={
                "申請時に、マイナンバーカードの電子署名を「必須」にすることができます。\n 申請者の種別が「個人」のみの場合に設定できます。"
              }
              checked={
                detail.requireAuthLevel.individual ===
                "MY_NUMBER_CARD_SIGNATURE"
              }
              onChange={function (): void {
                setDetail(
                  new ProcedureDetail({
                    ...detail,
                    requireAuthLevel: {
                      ...detail.requireAuthLevel,
                      individual:
                        detail.requireAuthLevel.individual ===
                        "MY_NUMBER_CARD_SIGNATURE"
                          ? "NONE"
                          : "MY_NUMBER_CARD_SIGNATURE",
                    },
                  }),
                );
              }}
            />
          </div>
          <div className="field">
            <Toggle
              id={mojToggleId}
              disabled={!detail.isCorporateOnly() || procedure.isArchived()}
              label={"商業登記に基づく電子証明書"}
              description={
                "申請時に、商業登記に基づく電子証明書による電子署名を「必須」にすることができます。\n 申請者の種別が「法人」のみの場合に設定できます。"
              }
              checked={detail.requireAuthLevel.corporation === "MOJ_SIGNATURE"}
              onChange={() =>
                setDetail(
                  new ProcedureDetail({
                    ...detail,
                    requireAuthLevel: {
                      ...detail.requireAuthLevel,
                      corporation:
                        detail.requireAuthLevel.corporation === "MOJ_SIGNATURE"
                          ? "NONE"
                          : "MOJ_SIGNATURE",
                    },
                  }),
                )
              }
            />
          </div>
        </div>
        <div className="column has-text-right">
          <UpdateButton
            procedure={procedure}
            onClick={() => {
              onDraftUpdate(detail);
            }}
          />
        </div>
      </div>
    </>
  );
};

const QuotaSettingConflictMessage: React.FC = () => (
  <div className="notification is-warning is-light">
    <div>
      <span className={`icon has-text-warning`}>
        <i className={`fas fa-exclamation-triangle`} />
      </span>
      <strong>認証設定ができません</strong>
    </div>
    <div className="content is-size-7 ml-5 mt-1">
      <b>申請数の上限が設定されている手続きでは認証設定ができません。</b>
    </div>
  </div>
);
